export const USER_EMAIL_LIMIT = 500
export const USER_PREFERRED_NAME_LIMIT = 100
export const USER_OVERLIMIT_COPY_LIMIT = 500
export const USER_REASON_REMOVED_LIMIT = 2000

export const TEAM_NAME_LIMIT = 100

export const BATCH_ORG_USER_REMOVAL_LIMIT = 100

export const USER_AI_TOKENS_MONTHLY_LIMIT = 500_000 // One BIG request every day
